"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function SET_CONVERT(state, convert) {
    state.convert = convert;
}
exports.SET_CONVERT = SET_CONVERT;
function SET_EXCHANGE_RATES(state, exchangeRates) {
    state.exchangeRates = exchangeRates;
}
exports.SET_EXCHANGE_RATES = SET_EXCHANGE_RATES;
function SET_LOCATION(state, location) {
    state.location = location;
}
exports.SET_LOCATION = SET_LOCATION;
// export everything compliant to the vuex specification for getters
exports.default = {
    SET_CONVERT: SET_CONVERT,
    SET_EXCHANGE_RATES: SET_EXCHANGE_RATES,
    SET_LOCATION: SET_LOCATION,
};
//# sourceMappingURL=mutations.js.map